import React from "react";

const NewVocabCard = ({ vocab }) => {
  return (
    <div className="w-full max-w-4xl mx-auto mt-4">
      <div className="border border-gray-300 p-4 rounded-lg bg-white shadow-sm">
        <h3 className="font-semibold text-lg mb-3">Vocabulary Upgrade</h3>

        <div className="flex flex-col items-start gap-2">
          {/* Original */}
          <div className="w-full">
            <div className="text-xs font-semibold text-gray-700 mb-1">
              Your word
            </div>
            <div className="text-gray-900 font-bold text-base break-words">
              {vocab.original}
            </div>
          </div>

          {/* Arrow */}
          <div className="text-gray-500 text-lg leading-none select-none">↓</div>

          {/* Suggestion */}
          <div className="w-full">
            <div className="text-xs font-semibold text-gray-700 mb-1">
              Better word
            </div>
            <div className="text-green-700 font-bold text-base break-words">
              {vocab.suggestion}
            </div>
          </div>

          {/* Meaning */}
          <div className="w-full pt-2 border-t border-gray-200">
            <div className="text-xs font-semibold text-gray-700 mb-1">
              Meaning
            </div>
            <div className="text-gray-800 text-sm leading-relaxed break-words">
              {vocab.meaning}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewVocabCard;